import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ActiveListUpload.css";
import { Upload, message, Spin } from "antd";
import { DeleteOutlined, UploadOutlined } from "@ant-design/icons";
import { BaseUrl, FormConfig } from "../../Repository/BaseRepository";
import moment from "moment";
import { GetActiveListLastUploadedDate } from "../../Repository/HealthInsuranceRepository";
import { useDispatch} from "react-redux"; 
const ActiveListUpload = (props) => {
  const redirect = props.redirect;
  const [activeList, setActiveList] = useState([]);
  const [activitySpin, setActivitySpin] = useState(false);
  const [dateList, setDateList] = useState(null);
  const handleActivelistUpload = async (options) => {
    try {
      setActivitySpin(true);
      const { file, onSuccess, onError } = options;
      const updatedDeductionFile = { file, status: "uploading" };
      const formData = new FormData();
      formData.append("paychexFile", file);
      const response = await axios.post(
        `${BaseUrl}HealthInsurance/postactivelistdata`,
        formData,
        FormConfig
      );
      if (response.data.statusCode === 200) {
        onSuccess(file);
        message.success(`File uploaded successfully`);
        updatedDeductionFile.status = "done";
        setActiveList([updatedDeductionFile]);
        setActivitySpin(false);
        fetchData();
        if (redirect === "healthinsurance") {
          window.location.href = "/healthinsurance";
        }
      } else {
        onError(file);
        message.error(`File upload failed`);
        updatedDeductionFile.status = "error";
        setActiveList([updatedDeductionFile]);
        setActivitySpin(false);
      }
    } catch (error) {
      message.error(`File upload failed`);
      setActivitySpin(false);
    }
  };
  //getting the latest paychex uploaded Date
  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    try{
      const response=await GetActiveListLastUploadedDate();
      console.log(response);
      if(response && response.payload){
        const payloadObject = JSON.parse(response.payload);
        setDateList(payloadObject);
        console.log(payloadObject);
      }
    }catch(err){
      console.log(err);
    }
  };

  const itemActiveListRender = (originNode, file) => {
    let statusColor;
    if (file.status === "done") {
      statusColor = "green";
    } else if (file.status === "error") {
      statusColor = "#f55451";
    }
    let fileExists = false;
    if (activeList.length > 0) {
      fileExists = true;
    }
    return (
      <>
        <div style={{ display: "flex", alignItems: "center", height: "auto" }}>
          <div
            style={{
              color: statusColor,
              width: "100%",
              height: "auto",
              display: "flex",
              justifyContent: "space-between",
              marginTop: "2px",
              borderRadius: "4px",
            }}
          >
            {fileExists ? activeList[0].file.name : null}
          </div>
          <DeleteOutlined
            style={{ marginTop: "2px" }}
            onClick={() => setActiveList([])}
          />
        </div>
      </>
    );
  };
  return (
    <>
      <div className="activelist-upload-wholeclass">
        <div className="activeupload-class" style={{ height: 40 }}>
          <Upload.Dragger
            name="file"
            customRequest={handleActivelistUpload}
            itemRender={itemActiveListRender}
            fileList={activeList}
            accept=".xls,.xlsx"
            onRemove={() => setActiveList([])}
            style={{
              border: "1px solid rgba(0, 39, 102, 0.5)",
              boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
              borderRadius: 15,
              height: "40px",
            }}
          >
            <div className="content-file">
              <span style={{ color: "black" }}>Upload Active list</span>
              <UploadOutlined style={{ color: "black", fontSize: 17 }} />
            </div>
          </Upload.Dragger>
          <p style={{paddingLeft:"20px"}}> 
            Last Uploaded Date:{" "}
            {dateList &&
              dateList.HealthInsurancepaychexDate &&
              moment.utc(dateList.HealthInsurancepaychexDate).tz('Asia/Kolkata').format(
                "MM/DD/YYYY HH:mm:ss"
              )}
          </p>
        </div>
        <div className="xl-spinner" style={{ marginTop: 10 }}>
          {activitySpin ? <Spin size="medium" /> : null}
        </div>
      </div>
    </>
  );
};
export default ActiveListUpload;
